import React from "react";
import { skills } from "./Object/Skills";
import { Helmet, HelmetData } from "react-helmet-async";
import ToTop from "./components/Subassets/ToTop";
import { motion } from "framer-motion";
import LazyLoad from "react-lazy-load";

const helmetData = new HelmetData({});
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const Skills = () => {
  return (
    <>
      <Helmet helmetData={helmetData}>
        <meta
          name="description"
          content="About my Skills | Portfolio | My skills for a job and how profecient i am in that as frontend developer"
        />

        <title>DevProfile | All SKills</title>
      </Helmet>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, delay: 1 }}
        transition={{
          ease: "easeInOut",
          duration: 0.7,
          delay: 0.15,
        }}
      >
        <section
          name="Skills"
          aria-label="skill heading"
          className="py-6 pt-8 text-center bg-slate-800"
        >
          <h1 className="inline text-4xl font-bold text-gray-200 border-b-4 rounded border-cyan-600">
            All Skills
          </h1>
        </section>
        <section
          aria-label="skills section"
          className="flex items-center justify-center bg-slate-900 "
        >
          <div className="mx-4 my-8 overflow-hidden divide-y divide-gray-200 rounded-lg shadow-xl max-w-7xl shadow-gray-900 backdrop-blur-xl sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0">
            {skills.map((skill) => (
              <div
                key={skill.id}
                className={classNames(
                  skill.id === 0
                    ? "rounded-tl-lg rounded-tr-lg sm:rounded-tr-none"
                    : "",
                  skill.id === 1 ? "sm:rounded-tr-lg" : "",
                  skill.id === skills.length - 2 ? "sm:rounded-bl-lg" : "",
                  skill.id === skills.length - 1
                    ? "rounded-bl-lg rounded-br-lg sm:rounded-bl-none"
                    : "",
                  "relative group bg-slate-800/90 backdrop-brightness-100 backdrop-blur-xl p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-cyan-500"
                )}
              >
                <article aria-label={skill.title}>
                  <figure
                    aria-label={skill.title}
                    className="inline-flex p-3 rounded-lg ring-4 ring-white"
                  >
                    <LazyLoad>
                      <img
                        src={skill.icon}
                        className="w-6 h-6 duration-300 group-hover:scale-150"
                        alt={skill.title}
                      />
                    </LazyLoad>
                  </figure>
                  <article
                    aria-label="rating"
                    className="py-3 text-xs font-bold text-white"
                  >
                    Rating : {skill.rating}
                  </article>
                </article>
                <hgroup aria-label="skill information" className="mt-4 ">
                  <h3 className="text-lg font-medium duration-1000 group-hover:translate-x-10 text-cyan-500">
                    <span className="duration-200 group-hover:text-2xl focus:outline-none">
                      {/* Extend touch target to entire panel */}
                      <span className="absolute inset-0" aria-hidden="true" />
                      {skill.title}
                    </span>
                  </h3>
                  <p
                    aria-label={skill.description}
                    className="mt-2 text-sm text-cyan-100"
                  >
                    {skill.description}
                  </p>
                </hgroup>
                <a
                  href={skill.href}
                  className="absolute text-gray-300 top-6 right-6 hover:text-gray-400"
                  aria-label={skill.href}
                  id={skill.title}
                  rel="exteranl noreferrer noopener"
                  title="linkedin page"
                  target="_blank"
                >
                  <svg
                    aria-label="redirect icon"
                    className="w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
                  </svg>
                </a>
              </div>
            ))}
          </div>
        </section>
        <ToTop name="Skills" />
      </motion.div>
    </>
  );
};

export default Skills;
